import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import { useDispatch } from "react-redux";
import { cancelFlowExecution } from "redux/actions/flowDesigner/flowExecutionActionCreator";

export const CancelExecutionDialog = ({ showDialog, closeDialog }) => {
  const dispatch = useDispatch();
  const { user } = useAuth0();

  const handleCancelExecution = () => {
    dispatch(cancelFlowExecution(user?.stripeId));
    closeDialog();
  };

  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="deleteGroupDialogTitle"
      aria-describedby="deleteGroupDialogDescription"
    >
      <DialogTitle id="deleteGroupDialogTitle">Cancel execution?</DialogTitle>
      <DialogContent>
        <DialogContentText id="deleteGroupDialogDescription">
          Do you really want to cancel the execution?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="outlined" color="primary" onClick={closeDialog}>
          No
        </SoftButton>
        <SoftButton onClick={handleCancelExecution} color="primary">
          Yes
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};
